import { useContext, useMemo, useRef } from 'react';

import { Tooltip } from '@atom/mui';
import colors from '@atom/styles/colors';
import fonts from '@atom/styles/fonts';
import { WorkOrder } from '@atom/types/work';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';
import { getWorkOrderStatusCalendarColor } from '@atom/utilities/workOrderStatusUtilities';

import WorkOrdersContext from '../WorkOrdersContext';

interface Props {
  workOrder: WorkOrder;
}

const styles = {
  event: {
    fontSize: fonts.sm,
    color: colors.neutral.dim,
    borderRadius: '4px',
    height: '18px',
    padding: '0 4px',
    margin: '1px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '100%',
  },
};

const WorkOrdersCalendarEvent = (props: Props) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { workOrder } = props;
  const { input, setInput } = useContext(WorkOrdersContext);

  const eventStyle = {
    ...styles.event,
    ...{ backgroundColor: getWorkOrderStatusCalendarColor(workOrder.statusId) },
  };

  const overflowing: boolean = useMemo(() => {
    if (isNilOrEmpty(containerRef.current)) {
      return false;
    }
    const { offsetWidth, scrollWidth } = containerRef.current;
    return offsetWidth < scrollWidth;
  }, [containerRef.current]);

  return (
    <div
      onClick={() => setInput({ ...input, workOrderId: workOrder.id })}
      style={eventStyle}
      ref={containerRef}
    >
      {overflowing ? (
        <Tooltip title={workOrder.name}>
          <span>{workOrder.name}</span>
        </Tooltip>
      ) : (
        workOrder.name
      )}
    </div>
  );
};

export default WorkOrdersCalendarEvent;
